import { DownOutlined } from '@ant-design/icons';
import { AgGridReact } from 'ag-grid-react';
import { Button, Dropdown, Space } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { FC, useMemo } from 'react';

import { loadGridState, resetGridState, saveGridState } from 'src/utils/ag-grid-util';

interface AgGridSettingsButtonsProps {
  gridRef: AgGridReact | null;
  tableId: string;
  size?: SizeType;
  /** 저장 슬롯 개수 (1~3). 2 이상이면 드롭다운으로 슬롯 선택 가능. 기본값 1 (기존 동작) */
  saveSlotCount?: 1 | 2 | 3;
}

const buttonConfigs = [
  { label: '설정 저장', action: saveGridState },
  { label: '설정 불러오기', action: loadGridState },
  { label: '설정 초기화', action: resetGridState },
] as const;

const getSlotKey = (tableId: string, slot: number): string => (slot === 1 ? tableId : `${tableId}__slot${slot}`);

const AgGridSettingsButtons: FC<AgGridSettingsButtonsProps> = ({ gridRef, tableId, size, saveSlotCount = 1 }) => {
  const menuItemsByAction = useMemo(
    () =>
      buttonConfigs.map(({ label, action }) => ({
        label,
        items: Array.from({ length: saveSlotCount }, (_, i) => ({
          key: `${label}-${i + 1}`,
          label: `설정 ${i + 1}`,
          onClick: () => action(gridRef, getSlotKey(tableId, i + 1)),
        })),
      })),
    [gridRef, tableId, saveSlotCount]
  );

  const spacing = size === 'small' ? 2 : 4;

  if (saveSlotCount <= 1) {
    return (
      <Space size={spacing}>
        {buttonConfigs.map(({ label, action }) => (
          <Button key={label} size={size} onClick={() => action(gridRef, tableId)}>
            {label}
          </Button>
        ))}
      </Space>
    );
  }

  return (
    <Space size={spacing}>
      {menuItemsByAction.map(({ label, items }) => (
        <Dropdown key={label} menu={{ items }} trigger={['click']}>
          <Button size={size} icon={<DownOutlined />} iconPosition='end'>
            {label}
          </Button>
        </Dropdown>
      ))}
    </Space>
  );
};

export default AgGridSettingsButtons;
